import { useEffect, useState } from "react";
import { Position } from "../flyout/types";
import { useMediaQuery } from "../grid";
import { MOBILE_POSITIONS, TABLET_AND_WIDER_POSITIONS } from "./constants";

export const useFlyoutPositions = () => {
  const isMobile = useMediaQuery("mobile");
  const flyoutPositions = isMobile
    ? MOBILE_POSITIONS
    : TABLET_AND_WIDER_POSITIONS;

  const [position, setPosition] = useState<Position>(flyoutPositions[0]);

  useEffect(() => {
    setPosition(flyoutPositions[0]);
  }, [flyoutPositions]);

  return {
    currentPosition: position,
    setFlyoutPosition: setPosition,
    flyoutPositions,
    isMobile,
  };
};
